import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // Add Basic Auth Header to all requests
    const headers: any = {
      Authorization: `Basic aWRlb2Nhc3RJREVPQVBJOjFkMzBjNHN0UGFzczI2IQ==`,
    };
    const userStore = localStorage.getItem("icuser_STORE");
    if (userStore) {
      try {
        const users = JSON.parse(userStore);
        if (users && users.length > 0 && users[0].IdGuid) {
          headers["AuthToken"] = users[0].IdGuid;
        }
      } catch (e) {
        console.error(e);
      }
    }

    request = request.clone({
      setHeaders: headers,
    });

    return next.handle(request);
  }
}
